import { injectPartnerFontFace } from '../injectPartnerFontFace'
import { SHERWIN_WILLIAMS_FONT_FACE_CSS } from './sherwinWilliamsFontFace'

/**
 * Side-effect-only module: importing it registers the CustomFont-SW `@font-face` rules via
 * `injectPartnerFontFace`, which no-ops on repeat calls. Every SW component that renders text in
 * that font imports this directly (rather than one importing another for the side effect) so the
 * registration doesn't depend on which component a bundler happens to evaluate first.
 */
injectPartnerFontFace('sw-font-face', SHERWIN_WILLIAMS_FONT_FACE_CSS)
